import React from 'react';

import { StockStatus } from 'src/components/stock-status';
import { StockStatusStates } from 'src/components/stock-status/types';
import { Price } from 'src/components/product-card-new/components/price';

import * as S from '../../styles';
import { IconChevronRight } from '@prisjakt/ui/icon';

type Props = {
  price: number;
  stockStatus?: StockStatusStates | null;
  featured: boolean;
  isDeal: boolean;
};

export const PriceInformation = (props: Props) => {
  const { price, stockStatus, isDeal, featured } = props;

  return (
    <S.PriceInformation>
      <StockStatus status={stockStatus || undefined} />
      <S.PriceWrapper $featured={featured}>
        <Price price={price} isDeal={isDeal} />
      </S.PriceWrapper>
      {featured && (
        <S.OfferButton>
          <IconChevronRight color="base0" />
        </S.OfferButton>
      )}
    </S.PriceInformation>
  );
};
